/**
 * Which build is running, read from the `<meta>` tags `vite.config.ts` stamps
 * into index.html.
 *
 * Not from `import.meta.env`, which is what this used to be: a value inlined
 * into the JavaScript changes the entry chunk's name on every commit, and with
 * it the name of every chunk that imports the entry, so each deploy discarded
 * the whole cached bundle. index.html is fetched fresh on every open and is the
 * document that named the chunks now running, so it answers the same question
 * without touching them.
 */
function readBuildMeta(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }

  return (
    document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ||
    undefined
  );
}

/**
 * The 7-character commit SHA CI tags the Docker image with, so whatever a user
 * reads off the settings screen can be pasted straight into `Rollback
 * production` without looking anything up.
 *
 * Only CI sets it, so a local `nx serve` reports 'dev' rather than a stale or
 * invented SHA.
 */
export const APP_VERSION: string = readBuildMeta('app-version') || 'dev';

/**
 * The full commit SHA: Sentry's `release`, which events and spans are tagged
 * with and source maps are uploaded under. Undefined when the page was not
 * built by Vite with a commit to hand.
 */
export const APP_RELEASE: string | undefined = readBuildMeta('app-release');
